import React, { useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
/// images
import icon from "../../../images/Flipjoblogoicon.png";
import fullLogo from '../../../images/Flipjoblogotest.png'

const NavHeader = () => {
   const [toggle, setToggle] = useState(false);
   const loggedInUser = JSON.parse(localStorage.getItem('user'))
   var navTo = loggedInUser.roles === "Accountant" ? '/list-invoice'
      : loggedInUser.roles !== "Recruitment Agent" ? '/dashboard'
         : loggedInUser.agentStatus === 'Unverified' || loggedInUser.agentStatus === 'Approved'
            ? '/agent-profile' : '/list-job'
   return (
      <div className="nav-header">
         <Link to={navTo} className="brand-logo">
            <img className="logo-abbr" src={icon} alt="" />
            <img className="brand-title" src={fullLogo} alt="" />
         </Link>

         <div className="nav-control" onClick={() => setToggle(!toggle)}>
            <div className={`hamburger ${toggle ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
      </div >
   );
};

export default NavHeader;
